document.addEventListener("DOMContentLoaded", () => {
  // console.log("pp generic js run >>");

  const thumbnailSwiper = new Swiper(".generic-pp-thumbs", {
    slidesPerView: 6,
    spaceBetween: 16,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  const genericPPSwiper = new Swiper(".generic-pp-swiper", {
    slidesPerView: 1,
    spaceBetween: 16,
    thumbs: {
      swiper: thumbnailSwiper,
    },
  });

  const installationSteps = document.querySelectorAll(".installation-step");

  // Loop through each installation step and attach an event listener
  function openAccordion(content, chevron) {
    content.style.height = content.scrollHeight + 20 + "px";
    content.style.paddingTop = "10px";
    content.style.paddingBottom = "10px";
    chevron.classList.add("opened");
  }

  function closeAccordion(content, chevron) {
    content.style.height = "0";
    content.style.paddingTop = "0";
    content.style.paddingBottom = "0";
    chevron.classList.remove("opened");
  }

  installationSteps.forEach((step, i) => {
    const title = step.querySelector(".installation-step-title");
    const content = step.querySelector(".installation-step-content");

    // Add click event to toggle the accordion
    title.addEventListener("click", function () {
      const isOpen = content.style.height !== "0px";
      const chevron = title.querySelector(".step-chevron");

      // Close all other open accordions
      installationSteps.forEach((otherStep) => {
        const otherContent = otherStep.querySelector(
          ".installation-step-content"
        );
        const otherChevron = otherStep.querySelector(".step-chevron");
        if (otherContent !== content) {
          closeAccordion(otherContent, otherChevron);
        }
      });

      isOpen
        ? closeAccordion(content, chevron)
        : openAccordion(content, chevron);
    });

    // Dynamically opens first accordion
    if (i === 0) {
      setTimeout(() => {
        title.click();
      }, 1000);
    }
  });

  // CARDS START
  const whyCwCards = new Swiper(".pp-generic-why__cards", {
    slidesPerView: 1.5,
    spaceBetween: 16,
    breakpoints: {
      650: {
        slidesPerView: 2.2,
      },
      990: {
        slidesPerView: 3.2,
      },
      1200: {
        slidesPerView: 4.2,
      },
    },
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
  });
  // CARDS END

  const mobileAppSwiperContainer = document.querySelector(".mobile-app-swiper");
  const mobileAppSwiperThumbnailContainer = document.querySelector(
    ".mobile-app-thumbnail"
  );
  const itemCount = mobileAppSwiperThumbnailContainer.dataset.slideCount;
  const mobileAppSwiper = new Swiper(mobileAppSwiperContainer, {});
  const mobileAppThumbnailSwiper = new Swiper(
    mobileAppSwiperThumbnailContainer,
    {
      slidesPerView: 1.5,
      spaceBetween: 10,
      breakpoints: {
        990: {
          grid: {
            rows: Number(itemCount),
          },  
          slidesPerView: 1,
          spaceBetween: 16,
        },
      },
    }
  );

  mobileAppSwiper.on("activeIndexChange", (swiper) => {
    const idx = swiper.activeIndex;
    mobileAppThumbnailSwiper.slideTo(swiper.activeIndex);
    const activated = mobileAppThumbnailSwiper.slides.find((item) => {
      return item.classList.contains("activated");
    });
    activated.classList.toggle("activated");
    mobileAppThumbnailSwiper.slides[idx].classList.toggle("activated");
  });

  mobileAppSwiperThumbnailContainer
    .querySelectorAll(".swiper-slide")
    .forEach((slide, idx) => {
      slide.addEventListener("click", (item) => {
        mobileAppSwiper.slideTo(idx);
      });
    });
});
